import script from "./AccountRebateRelation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountRebateRelation.vue?vue&type=script&setup=true&lang=ts"

import "./AccountRebateRelation.vue?vue&type=style&index=0&id=c3129252&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3129252"]])

export default __exports__